import intlMessagesEN from "./i18n/localization/en.json";
import intlMessagesVi from "./i18n/localization/vi.json";
import initSagas from "./Store/initSagas";
import initReducer from "./Store/initReducer";

export default {
  name: "Authenticate",
  dir: "Authenticate",
  pathRoot: "",
  routes: [
    {
      url: "register",
      component: "Page/Register",
      layout: "BlankLayout",
      meta: {
        authRoute: true,
      },
      props: {
        title: "Đăng Ký | Trắc nghiệm toàn diện Tâm Trí Lực",
        titleI18n: "Auth:register",
      },
    },
    {
      url: "forgot-password",
      component: "Page/ForgotPassword",
      layout: "BlankLayout",
      meta: {
        authRoute: true,
      },
      props: {
        title: "Quên mật khẩu | Trắc nghiệm toàn diện Tâm Trí Lực",
        titleI18n: "Auth:forgotPassword",
      },
    },
    {
      url: "",
      component: "Page/index",
      layout: "BlankLayout",
      meta: {
        authRoute: true,
      },
      props: {
        title: "Đăng nhập | Trắc nghiệm toàn diện Tâm Trí Lực",
        titleI18n: "Auth:title",
        exact: true,
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: false,
  sagas: initSagas,
  redux: initReducer,
  role: ["quickquiZFullRole", "CTV"],
};
